/*!
 * apiai
 * Copyright(c) 2015 http://api.ai/
 * Apache 2.0 Licensed
 */

'use strict';

module.exports = require("./module/apiai");


//////////////////
// WEBPACK FOOTER
// ./~/apiai/index.js
// module id = 99
// module chunks = 2